<template>
  <div>
    <label>{{label}}</label>
    <multiselect
      v-model="selValueModel"
      :track-by="ctrlCode"
      :label="ctrlName"
      placeholder="Select"
      :options="options"
      :searchable="isSearchable"
      :multiple="isMultiple"
      :allow-empty="false"
      :taggable="false"
      :loading="isInValidOptions()"
      @input="emitVal"
      deselectLabel
      deselectGroupLabel
      selectLabel
      selectedLabel
    >
      <template slot="singleLabel" slot-scope="{ option }">{{ option[ctrlName] }}</template>
      <template slot="option" slot-scope="props">
        <div>
          <span>{{ props.option[ctrlName] }}</span>
          <strong class="right" v-if="isShowCode">{{ props.option[ctrlCode] }}</strong>
        </div>
      </template>
      <template #noResult>
                <strong >
                  {{resultEmpty}}
                </strong>
              </template>
              <template #noOptions>
                <strong >
                  {{optionEmpty}}
                </strong>
              </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Logger from "../../services/logger";

import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES
} from "../../config/API_DATA";

import { VALIDATE_SUCCESS_RES, getErrorMessage } from "../../util/apiValidate";
import { handleJWT, getErrorAlertValue } from "../../util/util";
import {SECTOR_TYPE } from "../../util/constants";
import BaseConfiguration from "../../config/base.js";

export default {
  name: "cSector",

  components: {
    Multiselect
  },
  model: {
    prop: "selValue"
  },

  props: {
    selValue: {
      type: Object | Array,
      default: []
    },
    isShowCode: {
      type: Boolean,
      default: false
    },

    isMultiple: {
      type: Boolean,
      default: false
    },
    isSearchable: {
      type: Boolean,
      default: false
    },
    ctrlName: {
      type: String,
      default: ""
    },
    ctrlCode: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
     resultEmpty: {
     type: String,
     // default: 'No matching items found'
     default: function () {
    return this.$t("cSector.resEmpty") }
   },
   optionEmpty: {
     type: String,
     default: function () {
    return this.$t("cSector.optEmpty") }
   },
  },

  data: () => ({
    options: [],
    selected: false,
    selValueModel: {
      name: null,
      code: null
    },
    alertValue: null
  }),

  watch: {
    selValue(val) {
      if (val !== this.selValueModel) {
        this.selValueModel = val;
      }
    }
  },

  methods: {
    emitVal(value) {
      this.$emit("input", value);
    },

    isInValidOptions() {
      let retValue = false;
      if (this.options && this.options.length > 0)
        //check options length
        retValue = false;
      else retValue = true;
      return retValue;
    },

    getSectorOptions() {
      try {
        this.options = this.getSectorList();
        if (!(this.selValueModel && this.selValueModel.code && this.selValueModel.name)) {
          this.selValueModel = this.getDefaultSector(this.options);
          this.emitVal(this.selValueModel);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          "cSector",
          "error in getSectorOptions",
          err.toString(),
          "getSectorOptions",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getDefaultSector(pOptionsList) {
      let retValue;
      try {
        if (pOptionsList != null && pOptionsList.length > 0) {
          for (let i = 0; i < pOptionsList.length; i++) {
            if (pOptionsList[i].code ==  SECTOR_TYPE.ALL) {
              retValue = pOptionsList[i];
              break;
            }
          }
        } else {
          throw "invalid options list";
        }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          "cSector",
          "error in getDefaultSector",
          err.toString(),
          "getDefaultSector",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getSectorList() {
      return [//op
          {
            name: this.$t('sectorType.ALL'),
            code:  SECTOR_TYPE.ALL
          },
          {
            name: this. $t('sectorType.DOM'),
            code: SECTOR_TYPE.DOM
          },
          {
            name:this.$t('sectorType.INT'),
            code: SECTOR_TYPE.INT
          }
        ];
    }
  },

  created() {
  
    this.selValueModel = this.selValue;
   this.getSectorOptions();
  }
};
</script>